import {Action} from '@ngrx/store';

import {type} from '../utilities/type';
import {Order} from '../../order/models/order';

export const currentOrderActionTypes = {
  LOAD: type('[Current Order] Load'),
  LOAD_SUCCESS: type('[Current Order] Load Success'),
  LOAD_FAIL: type('[Current order] Load Fail')
};

export class LoadCurrentOrderAction implements Action {
  readonly type = currentOrderActionTypes.LOAD;
  constructor(public payload?: string) {}
}

export class LoadCurrentOrderSuccessAction implements Action {
  readonly type = currentOrderActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Order) {
  }
}

export class LoadCurrentOrderFailAction implements Action {
  readonly type = currentOrderActionTypes.LOAD_FAIL;

  constructor(public payload?: string) {}
}
